import { MatrixClient } from 'matrix-js-sdk';

/**
 * Wrapper für MatrixClient mit Herkunft
 * Begründung: Hilfsklasse
 */
export class ClientWithOrigin {
  private constructor(
    private readonly _client: MatrixClient | null,
    private readonly _origin: Origin
  ) {}

  get client(): MatrixClient | null {
    return this._client;
  }

  get origin(): Origin {
    return this._origin;
  }

  static register(client: MatrixClient): ClientWithOrigin {
    return new ClientWithOrigin(client, 'register');
  }

  static login(client: MatrixClient): ClientWithOrigin {
    return new ClientWithOrigin(client, 'login');
  }

  static restoreSession(client: MatrixClient): ClientWithOrigin {
    return new ClientWithOrigin(client, 'restoreSession');
  }

  static logout(): ClientWithOrigin {
    return new ClientWithOrigin(null, 'logout');
  }
}

type Origin = 'register' | 'login' | 'restoreSession' | 'logout';
